var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import Divider from "../Divider/index.js";
import { mapResponsiveProps } from "@bookingcom/bui-core/utilities/responsive";
import { classNames, responsiveClassNames, } from "@bookingcom/bui-core/utilities/classNames";
import mixinClassNames from "../../utilities/mixinClassNames.js";
import { responsiveStyles, mixinStyles, } from "@bookingcom/bui-core/utilities/styles";
import styles from "@bookingcom/bui-core/css/Stack.module.css";
var StackItem = function (props) {
    var split = props.split, grow = props.grow, shrink = props.shrink, alignSelf = props.alignSelf, children = props.children, tagName = props.tagName, className = props.className, attributes = props.attributes;
    var TagName = tagName || "div";
    var itemClassNames = classNames(styles.item, grow && styles["item--grow"], (grow || shrink) && styles["item--shrink"], split && styles["item--split"], alignSelf && styles["item--align-self-".concat(alignSelf)], className);
    return (React.createElement(TagName, __assign({}, attributes, { className: itemClassNames }), children));
};
var Stack = function (props) {
    var className = props.className, attributes = props.attributes, children = props.children, tagName = props.tagName, _a = props.direction, direction = _a === void 0 ? "column" : _a, _b = props.gap, gap = _b === void 0 ? 2 : _b, alignItems = props.alignItems, justifyContent = props.justifyContent, wrap = props.wrap, _c = props.grow, grow = _c === void 0 ? false : _c, split = props.split, alignSelf = props.alignSelf, mixin = props.mixin, divided = props.divided;
    var TagName = tagName || "div";
    var hasGrowItem = React.Children.toArray(children).some(function (child) { var _a; return (_a = child.props) === null || _a === void 0 ? void 0 : _a.grow; });
    var rootClassNames = classNames(styles.root, responsiveClassNames(styles, "root--direction", direction), responsiveClassNames(styles, "root--align-items", alignItems), responsiveClassNames(styles, "root--justify-content", justifyContent), hasGrowItem && styles["root--nowrap"], split && styles["root--split"], responsiveClassNames(styles, "root--wrap", wrap), responsiveClassNames(styles, "root--grow", grow), alignSelf && responsiveClassNames(styles, "root--align-self", alignSelf), mixinClassNames(mixin), className);
    var variables = __assign(__assign(__assign({}, responsiveStyles(gap, "stack", "gap")), mixinStyles(mixin)), ((attributes === null || attributes === void 0 ? void 0 : attributes.style) || {}));
    var renderDividedChildrem = function () {
        var isDividerVertical = mapResponsiveProps(direction, {
            column: false,
            "column-reverse": false,
            row: true,
            "row-reverse": true,
        });
        return React.Children.toArray(children).reduce(function (acc, child, index) {
            if (index > 0) {
                acc.push(React.createElement("div", { className: styles.divider, key: index },
                    React.createElement(Divider, { vertical: isDividerVertical })), React.cloneElement(child, { key: "pair-".concat(index) }));
            }
            else {
                acc.push(React.cloneElement(child, { key: "single-".concat(index) }));
            }
            return acc;
        }, []);
    };
    return (React.createElement(TagName, __assign({}, attributes, { style: variables, className: rootClassNames }), divided ? renderDividedChildrem() : children));
};
StackItem.displayName = "Stack.Item";
Stack.Item = StackItem;
export default Stack;
